import React from 'react';
import PropTypes from 'prop-types';
import NetworkStatus from './NetworkStatus';

const Layout = ({ children }) => {
  return (
    <>
      <NetworkStatus />

      <div className="bg-blue">
        <main>{children}</main>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
